// removed by extract-text-webpack-plugin
module.exports = {"block":"_30lhkNEPOfUQx8389umNCW","header":"_2vSaxBvzJ7voch9wQlm7Dr","content":"TfjkJr1ZVAfWEmwRe8G6S","items":"xWI2ftTbGcF3Y7qjnuILH","readMore":"sxyzGGeCVweOCNV6JdS8i","footer":"_16CzBPJoSuibkNaM_pEyD3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryBlock/GalleryBlock.module.scss
// module id = 768
// module chunks = 0